(() => {
  if (window.SleekImageRotatorReady) return;
  window.SleekImageRotatorReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  const init = root => {
    if (root.dataset.rotationReady) return;
    root.dataset.rotationReady = 'true';

    const images = [...root.querySelectorAll('.sleek-image-rotator__image')];
    if (images.length < 2) return;

    const controls = root.querySelector('.sleek-image-rotator__controls');
    if (controls) controls.hidden = true;

    let index = 0;
    let timer = null;
    let inView = false;
    let pausedForFocus = false;
    let revision = 0;

    const show = async delta => {
      const request = ++revision;
      const next = (index + delta + images.length) % images.length;
      try { await images[next].decode(); } catch {}
      if (request !== revision) return;
      images[index].classList.remove('is-current');
      index = next;
      images[index].classList.add('is-current');
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!inView || pausedForFocus || reduced.matches || document.hidden) return;
      timer = setInterval(() => show(1), 3500);
    };

    root.addEventListener('pointerenter', () => {
      if (!reduced.matches) show(1);
    });
    root.addEventListener('focusin', () => {
      pausedForFocus = true;
      stop();
    });
    root.addEventListener('focusout', () => {
      pausedForFocus = false;
      start();
    });

    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      inView ? start() : stop();
    }, { threshold: 0.35 });
    observer.observe(root);

    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    reduced.addEventListener('change', () => reduced.matches ? stop() : start());
  };

  const scan = parent => parent.querySelectorAll('[data-sleek-rotator]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType !== 1) return;
    if (node.matches('[data-sleek-rotator]')) init(node);
    scan(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();